module.exports = __webpack_public_path__ + "images/Edit.575c8f57905f6151c75514e32406b362.svg";